import PropTypes from 'prop-types';
import React from 'react';

import { Container } from 'components/Grid';
import { SecondaryHeading, TertiaryHeading } from 'components/Headings';
import RichText from 'components/RichText';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const BrandValuesModule = ({ backgroundColor, showModule, heading, items, trackLinkClick }) => {
  if (!showModule) {
    return null;
  }

  return (
    <div className="BrandValuesModule">
      <Container>
        <SecondaryHeading className="BrandValuesModule__heading">{heading}</SecondaryHeading>

        <ul className="BrandValuesModule__list">
          {items.map(({ heading: itemHeading, description, link, linkLabel }) => (
            <li className="BrandValuesModule__item" key={itemHeading}>
              <TertiaryHeading className="BrandValuesModule__item-heading">
                {itemHeading}
              </TertiaryHeading>
              <RichText className="BrandValuesModule__item-description" content={description} />
              {link && linkLabel && (
                <a
                  className="BrandValuesModule__item-link"
                  href={link}
                  onClick={() => trackLinkClick(`${linkLabel} - ${itemHeading} - ${description}`)}
                >
                  {linkLabel}
                </a>
              )}
            </li>
          ))}
        </ul>
      </Container>
      <style jsx>{`
        .BrandValuesModule {
          position: relative;
          background-color: ${backgroundColor};
          padding: ${Theme.get('spacing') * 8}px 0;
          color: ${Theme.get('colors-black')};
        }

        .BrandValuesModule__list {
          display: flex;
          flex-direction: column;
          gap: ${Theme.get('spacing') * 4}px;
        }

        .BrandValuesModule__item {
          display: flex;
          flex-direction: column;
        }

        .BrandValuesModule__item-link {
          margin-top: auto;
          line-height: 1.5;
          text-decoration: underline;
          font-size: ${Theme.get('font-size-description-px')};
          color: ${Theme.get('colors-black')};
        }

        @media ${mediumUp} {
          .BrandValuesModule {
            padding: ${Theme.get('spacing') * 13}px 0;
          }

          .BrandValuesModule__list {
            flex-direction: row;
          }
        }
      `}</style>

      <style global jsx>{`
        .BrandValuesModule__heading.typography--secondary-heading {
          margin-bottom: ${Theme.get('spacing') * 4}px;
        }

        .BrandValuesModule__item-heading.typography--tertiary-heading {
          margin-bottom: ${Theme.get('spacing') * 1.5}px;
        }

        .BrandValuesModule__item-description {
          margin-top: auto;
        }

        .BrandValuesModule__item-description p.Paragraph,
        .BrandValuesModule__item-description strong.typography--strong {
          line-height: 1.5;
          font-size: ${Theme.get('font-size-description-px')};
          margin-bottom: 0;
        }
      `}</style>
    </div>
  );
};

BrandValuesModule.propTypes = {
  backgroundColor: PropTypes.string,
  heading: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.shape({}),
      link: PropTypes.string,
      linkLabel: PropTypes.string,
    })
  ),
  showModule: PropTypes.bool,
  trackLinkClick: PropTypes.func.isRequired,
};

BrandValuesModule.defaultProps = {
  backgroundColor: Theme.get('colors-white'),
  heading: '',
  items: [],
  showModule: false,
};

export default BrandValuesModule;
